import React from 'react'

export default class IconsDnDForm extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M8 13.3333H7.33333C6.97971 13.3333 6.64057 13.1929 6.39052 12.9428C6.14048 12.6928 6 12.3536 6 12C6 12.3536 5.85952 12.6928 5.60948 12.9428C5.35943 13.1929 5.02029 13.3333 4.66667 13.3333H4'
                    stroke='#0A0A0A'
                    stroke-width='1.25'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M8.66699 5.33325H13.3337C13.6873 5.33325 14.0264 5.47373 14.2765 5.72378C14.5265 5.97382 14.667 6.31296 14.667 6.66659V9.33325C14.667 9.68687 14.5265 10.026 14.2765 10.2761C14.0264 10.5261 13.6873 10.6666 13.3337 10.6666H8.66699'
                    stroke='#0A0A0A'
                    stroke-width='1.25'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M3.33301 10.6666H2.66634C2.31272 10.6666 1.97358 10.5261 1.72353 10.2761C1.47348 10.026 1.33301 9.68687 1.33301 9.33325V6.66659C1.33301 6.31296 1.47348 5.97382 1.72353 5.72378C1.97358 5.47373 2.31272 5.33325 2.66634 5.33325H3.33301'
                    stroke='#0A0A0A'
                    stroke-width='1.25'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M4 2.66675H4.66667C5.02029 2.66675 5.35943 2.80722 5.60948 3.05727C5.85952 3.30732 6 3.64646 6 4.00008C6 3.64646 6.14048 3.30732 6.39052 3.05727C6.64057 2.80722 6.97971 2.66675 7.33333 2.66675H8'
                    stroke='#0A0A0A'
                    stroke-width='1.25'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path d='M6 4V12' stroke='#0A0A0A' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round' />
            </svg>
        )
    }
}
